import { MenuItem, MenuList, styled, Typography } from '@mui/material';

import breakpoints from '../../../../constants/breakpoints';

type ChecklistItemProps = {
  'data-is-editing': boolean;
};

export const ChecklistItem = styled(MenuItem)<ChecklistItemProps>(
  ({ 'aria-selected': isDragging, 'data-is-editing': isEditing, theme }) => ({
    '& > .MuiSvgIcon-root': {
      marginTop: 'var(--spacing-small)',
    },
    '&:focus-visible': {
      boxShadow: 'none',
    },
    ...(isDragging && {
      borderRadius: 'var(--border-radius-tiny)',
      boxShadow: 'var(--elevation-3)',
    }),
    alignItems: 'flex-start',
    backgroundColor:
      isEditing && !isDragging
        ? theme.palette.action.hover
        : 'var(--color-background)',
    boxShadow: 'var(--elevation-1)',
    justifyContent: 'space-between',
    minHeight: 'auto',
    paddingBlock: 'var(--spacing-small)',
    paddingInline: 'var(--spacing-small)',
    transition: 'transform 0s',
    [theme.breakpoints.up(breakpoints.laptopS)]: {
      '& > :is(.MuiIconButton-root, .MuiSvgIcon-root)': {
        '&:focus-visible': {
          boxShadow: 'none',
        },
        opacity: 0,
        pointerEvents: 'none',
      },
      '&:is(:hover, :focus, :focus-within, .Mui-focusVisible)': {
        '& > :is(.MuiIconButton-root, .MuiSvgIcon-root)': {
          opacity: 1,
          pointerEvents: 'auto',
        },
      },
    },
    [theme.breakpoints.up(breakpoints.mobileL)]: {
      backgroundColor: 'transparent',
      border: 'var(--border-dark)',
      borderRadius: 'var(--border-radius-tiny)',
      boxShadow: 'var(--elevation-3)',
      paddingBlock: 'var(--spacing-tiny)',
      ...(isDragging && {
        '& > :is(.MuiSvgIcon-root)': {
          opacity: 1,
          pointerEvents: 'auto',
        },
        backgroundColor: theme.palette.action.hover,
      }),
    },
    [theme.breakpoints.down(breakpoints.laptopS)]: {
      '&.MuiButtonBase-root.MuiMenuItem-root:hover': {
        ...(!isEditing && { backgroundColor: 'var(--color-background)' }),
      },
    },
  }),
);

export const ChecklistItemContent = styled(Typography)(() => ({
  fontWeight: 'var(--font-weight-button-label)',
  padding: 'var(--spacing-small)',
  userSelect: 'text',
  whiteSpace: 'normal',
  width: '100%',
  wordBreak: 'break-word',
}));

export const ChecklistItems = styled(MenuList)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--spacing-tiny)',
  maxHeight: 'var(--preference-compose-list-height)',
  overflowY: 'auto',
  paddingInline: 'var(--spacing-small)',
  [theme.breakpoints.down(breakpoints.tabletS)]: {
    borderRadius: 'var(--border-radius-tiny)',
    gap: 1,
    maxHeight: 'var(--preference-compose-checklist-height)',
    padding: 0,
  },
}));
